const _excluded = ["analyticsName", "trackImpression", "cardStyle"],
  _excluded2 = ["variant", "clickable", "analyticsName"];
function cov_gid0f43ak() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Card/Card.tsx";
  var hash = "2c75e8ea7c98a5ebfcfd3636399d3e855efcc67b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Card/Card.tsx",
    statementMap: {
      "0": {
        start: {
          line: 38,
          column: 81
        },
        end: {
          line: 53,
          column: 1
        }
      },
      "1": {
        start: {
          line: 44,
          column: 20
        },
        end: {
          line: 44,
          column: 92
        }
      },
      "2": {
        start: {
          line: 45,
          column: 2
        },
        end: {
          line: 52,
          column: 4
        }
      },
      "3": {
        start: {
          line: 130,
          column: 41
        },
        end: {
          line: 142,
          column: 1
        }
      },
      "4": {
        start: {
          line: 131,
          column: 16
        },
        end: {
          line: 131,
          column: 72
        }
      },
      "5": {
        start: {
          line: 132,
          column: 2
        },
        end: {
          line: 134,
          column: 3
        }
      },
      "6": {
        start: {
          line: 133,
          column: 4
        },
        end: {
          line: 133,
          column: 91
        }
      },
      "7": {
        start: {
          line: 135,
          column: 2
        },
        end: {
          line: 141,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 38,
            column: 81
          },
          end: {
            line: 38,
            column: 82
          }
        },
        loc: {
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 53,
            column: 1
          }
        },
        line: 43
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 130,
            column: 41
          },
          end: {
            line: 130,
            column: 42
          }
        },
        loc: {
          start: {
            line: 130,
            column: 94
          },
          end: {
            line: 142,
            column: 1
          }
        },
        line: 130
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 132,
            column: 2
          },
          end: {
            line: 134,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 132,
            column: 2
          },
          end: {
            line: 134,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 132
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "2c75e8ea7c98a5ebfcfd3636399d3e855efcc67b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_gid0f43ak = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_gid0f43ak();
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { useTrackComponentInView } from "../../hooks/useObservabilitySafe.mjs";
import { useStyleConfig } from "../../system/utils/index.mjs";
import Flex from "../Flex/index.mjs";

/**
 * NOTE ABOUT METRIC TRACKING:
 * Card is set up to track impression events
 * It will only track impression events if:
 *  1) a non-empty analyticsName is passed down - Convention: {appName}-{cardName}
 *  2) card enters viewport (threshold is set at 100% for now.  threshold: Number between 0 and 1 indicates the percentage that should be visible before triggering.)
 *
 * Events will be sent to the journey service and will end up in the corresponding tables (e.g. journey_service_production.card_view_event for card impression events)
 * For more information on tracking please refer here: https://opendoor.atlassian.net/wiki/spaces/SELL/pages/1926201404/EDD+User+Behavior+Metrics+in+Bricks
 */
cov_gid0f43ak().s[0]++;
const CardWithTracking = _ref => {
  let {
      analyticsName,
      trackImpression,
      cardStyle
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_gid0f43ak().f[0]++;
  const inViewRef = (cov_gid0f43ak().s[1]++, useTrackComponentInView('cardViewEvent', trackImpression, analyticsName));
  cov_gid0f43ak().s[2]++;
  return /*#__PURE__*/React.createElement(Flex
  // __css has a lower priority than sx
  , _extends({
    ref: inViewRef,
    __css: cardStyle
  }, props));
};

/**
 * Cards are containers that are used to bring attention to an action that we
 * want the seller or buyer to take.  We have `Primary`, `Secondary`,
 * `Tertiary`, and `Outline` Cards with different use cases.
 *
 * *   `Primary` Cards should be used only once per page.
 *
 * *   `Secondary` Cards can be used more than once on a page.
 *
 * *   `Tertiary` Cards are used for content groupings and content callouts.
 *
 * *   `Outline` Cards may be used as an alternative to `Tertiary`.
 *
 *
 * Card variant variations
 * ------------------------------------------------------------------------------------------------
 *
 * "primary"
 *
 * "secondary"
 *
 * "tertiary"
 *
 * "outline"
 *
 * Accessibility
 *
 *
 * -----------------
 *
 * ####
 *
 * Clickable Cards
 *
 * Non-interactable elements should not have an `onClick` method. When an
 * element should be clickable, it should be wrapped in a `Button` component
 * with the `ghost` variant. This will ensure that the element is clickable and
 * has a hover state without adding interactive behaviors to the element.
 *
 * ###
 *
 * ✅ Pass
 *
 * <Button variant="ghost" onClick={() => {/* do something *&#47; }}
 * aria-label=""> <Card /> </Button>
 *
 *
 * ###
 *
 * 🛑 Fail
 *
 * <Card onClick={() => {/* do something *&#47; }} />
 *
 *
 * Analytics
 *
 *
 * -------------
 *
 * `Card` is set up to track impression events. It will only track impression
 * events if:
 *
 * 1.  a non-empty `analyticsName` is passed down (convention:
 * {appName}-{cardName})
 *
 * 2.  passing `trackImpression={true}` Card impression events will only be
 * tracked the first time that the card enters the viewport
 *
 *
 * Events will be sent to the journey service and will end up in the
 * corresponding tables (e.g.
 * journey\_service\_production.platform\_card\_view\_event for card impression
 * events). For more information on tracking please refer
 * here:[https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update](https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update)
 */
cov_gid0f43ak().s[3]++;
export const Card = _ref2 => {
  let {
      variant,
      clickable,
      analyticsName
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  cov_gid0f43ak().f[1]++;
  const style = (cov_gid0f43ak().s[4]++, useStyleConfig('Card', _objectSpread({
    variant,
    clickable
  }, props)));
  cov_gid0f43ak().s[5]++;
  if (analyticsName) {
    cov_gid0f43ak().b[0][0]++;
    cov_gid0f43ak().s[6]++;
    return /*#__PURE__*/React.createElement(CardWithTracking, _extends({
      cardStyle: style,
      analyticsName: analyticsName
    }, props));
  } else {
    cov_gid0f43ak().b[0][1]++;
  }
  cov_gid0f43ak().s[7]++;
  return /*#__PURE__*/React.createElement(Flex
  // __css has a lower priority than sx
  , _extends({
    __css: style
  }, props));
};
export default Card;